import React, { Component } from 'react';
import FileUploader from "./ImagenTexto/FileUploader";
import FileUploaderUpdate from "./ImagenTexto/FileUploaderUpdate";
import { MDBIcon, MDBInput } from 'mdbreact';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import { CargueImagenes, QuieroAsociarme_ } from '../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';

const validate = values => {
    const errors = {}
    if (!values.nombasociarme) {
        errors.nombasociarme = 'campo obligatorio'
    }
    if (!values.txtasociarme1) {
        errors.txtasociarme1 = 'campo obligatorio'
    }
    if (!values.txtasociarme2) {
        errors.txtasociarme2 = 'campo obligatorio'
    }
    return errors;
};

class ImagenTexto extends Component {
    uploader = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            estadoNuevo: false,
            errors: {},
            estadoCambioImg1: true,
            infoQAsociarme: [],
            nombasociarme: '',
            txtasociarme1: '',
            txtasociarme2: '',
            editnombasociarme: '',
            edittxtasociarme1: '',
            edittxtasociarme2: '',
            estadoImagen: false,
            displayColorPicker: false,
            rutaimgasociarm: '',
            color: '#FFFFFF',
            estadoSinInfo: false,
        };
    }

    async componentDidMount() {
        this.cargarInformacion();
    }

    cargarInformacion = () => {
        const data = {
            tran: 4,
            idquieroasoc: 0,
            nombasociarme: 'NA',
            rutaimgasociarm: 'NA',
            txtasociarme1: 'NA',
            txtasociarme2: 'NA',
            colortexto: 'NA',
            estado: 0,
            usucrea: 'NA'
        }
        QuieroAsociarme_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (!response.data[0].message) {
                        this.setState({
                            idSeleccionado: response.data[0].idquieroasoc
                        })
                        setTimeout(() => {
                            this.setState({
                                infoQAsociarme: response.data,
                                editnombasociarme: response.data[0].nombasociarme,
                                rutaimgasociarm: response.data[0].rutaimgasociarm,
                                edittxtasociarme1: response.data[0].txtasociarme1,
                                edittxtasociarme2: response.data[0].txtasociarme2,
                                color: response.data[0].colortexto,
                                estado: response.data[0].estado,
                                estadoSinInfo: true,
                                estadoImagen: true,
                            })
                            document.getElementById('' + response.data[0].idquieroasoc + '').style.background = "#f47216";
                            document.getElementById('' + response.data[0].idquieroasoc + '').style.color = "#fff";
                            document.getElementById('' + response.data[0].idquieroasoc + '').style.fontWeight = "bold";
                        }, 120);
                    } else {
                        this.setState({
                            estadoSinResultados: false,
                            estadoNuevo: true,
                            estadoCambioImg1: true,
                            estadoSinInfo: false
                        })
                    }
                } else { }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    text: 'Ocurrio un error al consumir el servicio!'
                })
            }
        });
    }

    textInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    cambioImagen1 = (name, file) => {
        this.setState({
            estadoCambioImg1: true
        });
    }

    cambioImagen = (name, file) => {
        this.setState({
            estadoCambioImg: true
        });
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleChange = (color) => {
        this.setState({ color: color.hex })
    };

    cargarImagen = () => {
        var formData = new FormData();
        if (undefined === this.uploader.current) return;
        
        formData.append("file", this.uploader.current.getFileObject());
        formData.append("rutaImagen", '/Quiero Asociarme/ImagenTexto/' + this.uploader.current.getFileName());
        CargueImagenes(formData).then(response => {
            if (response) {
                this.cargarInformacion();
            }
        });
    }

    insertarDatos = () => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });
        if (!Object.keys(result).length) {
            // formulario validado
            const data = {
                tran: 1,
                idquieroasoc: 0,
                nombasociarme: this.state.nombasociarme,
                rutaimgasociarm: '/Quiero Asociarme/ImagenTexto/' + this.uploader.current.getFileName(),
                txtasociarme1: this.state.txtasociarme1,
                txtasociarme2: this.state.txtasociarme2,
                colortexto: this.state.color,
                estado: 1,
                usucrea: sessionStorage.getItem('idusuario')
            }
            QuieroAsociarme_(data).then(response => {
                if (response.data.length > 0) {
                    if (response.data[0].message === "000000") {
                        this.cargarImagen();
                        Swal.fire({
                            icon: 'success',
                            title: 'Se agrego correctamente.'
                        })
                        this.setState({
                            estadoNuevo: false,
                            nombasociarme: '',
                            txtasociarme1: '',
                            txtasociarme2: '',
                            estadoImagen: false,
                            displayColorPicker: false,
                            rutafondoImg: '',
                            color: '#ffffff',
                        })
                        this.cargarInformacion();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al insertar.'
                        })
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error!'
                    })
                }
            });
        }
    }

    busquedaId = (id) => {
        document.getElementById('' + this.state.idSeleccionado + '').style.background = "#fff";
        document.getElementById('' + this.state.idSeleccionado + '').style.color = "#000";
        document.getElementById('' + this.state.idSeleccionado + '').style.fontWeight = "normal";
        document.getElementById('' + id + '').style.background = "#f47216";
        document.getElementById('' + id + '').style.color = "#fff";
        document.getElementById('' + id + '').style.fontWeight = "bold";
        this.setState({
            estadoCambioImg: false,
            est: !this.state.est,
            idSeleccionado: id
        })
        const data = {
            tran: 5,
            idquieroasoc: id,
            nombasociarme: 'NA',
            rutaimgasociarm: 'NA',
            txtasociarme1: 'NA',
            txtasociarme2: 'NA',
            colortexto: 'NA',
            estado: this.state.estado,
            usucrea: 'NA'
        }
        QuieroAsociarme_(data).then(response => {
            if (response.data.length > 0) {
                this.setState({
                    editnombasociarme: response.data[0].nombasociarme,
                    rutaimgasociarm: response.data[0].rutaimgasociarm,
                    edittxtasociarme1: response.data[0].txtasociarme1,
                    edittxtasociarme2: response.data[0].txtasociarme2,
                    edittxtslider3: response.data[0].txtslider3,
                    editposiciontexto: response.data[0].posiciontexto,
                    color: response.data[0].colortexto,
                    estado: response.data[0].estado,
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'No hay información'
                })
            }
        });
    }

    activar = (id) => {
        const data = {
            tran: 6,
            idquieroasoc: id,
            nombasociarme: 'NA',
            rutaimgasociarm: 'NA',
            txtasociarme1: 'NA',
            txtasociarme2: 'NA',
            colortexto: 'NA',
            estado: 1,
            usucrea: sessionStorage.getItem('idusuario')
        }
        QuieroAsociarme_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se activo satisfactoriamente'
                });
                document.getElementById('' + this.state.idSeleccionado + '').style.background = "#fff";
                document.getElementById('' + this.state.idSeleccionado + '').style.color = "#000";
                document.getElementById('' + this.state.idSeleccionado + '').style.fontWeight = "normal";
                this.cargarInformacion();
            }
        });
    }

    actualizarDatos = (id) => {
        var ruta = '';
        var capNombre = this.uploader.current.getFileName();
        if (capNombre === undefined || capNombre === null) {
            ruta = this.state.rutaimgasociarm;
        } else {
            ruta = '/Quiero Asociarme/ImagenTexto/' + this.uploader.current.getFileName();
        }
        const data = {
            tran: 1,
            idquieroasoc: id,
            nombasociarme: this.state.editnombasociarme,
            rutaimgasociarm: ruta,
            txtasociarme1: this.state.edittxtasociarme1,
            txtasociarme2: this.state.edittxtasociarme2,
            colortexto: this.state.color,
            estado: 1,
            usucrea: sessionStorage.getItem('idusuario')
        }
        QuieroAsociarme_(data).then(response => {
            if (response.data.length > 0) {
                if (response.data[0].message === "000000") {
                    this.cargarImagen();
                    this.setState({
                        estadoCambio: false,
                        estadoEditar: false,
                        editposiciontexto: ''
                    })
                    Swal.fire({
                        icon: 'success',
                        title: 'Se actualizo satisfactoriamente'
                    })
                    document.getElementById('' + this.state.idSeleccionado + '').style.background = "#fff";
                    document.getElementById('' + this.state.idSeleccionado + '').style.color = "#000";
                    document.getElementById('' + this.state.idSeleccionado + '').style.fontWeight = "normal";
                    this.cargarInformacion();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error al actualizar'
                    })
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrio un error!'
                })
            }
        });
    }

    handleNew = () => {
        this.setState({
            estadoNuevo: !this.state.estadoNuevo,
            errors: {},
        })
        if (this.state.estadoNuevo) {
            this.setState({
                errors: {},
            })
            this.cargarInformacion();
        }
    }

    render() {
        const { errors, estadoNuevo, infoQAsociarme, nombasociarme, estadoCambioImg1, estadoCambioImg, estadoSinInfo, txtasociarme1, txtasociarme2, estadoImagen, rutaimgasociarm } = this.state;
        const styles = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: this.state.color,
                    // background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <React.Fragment>
                <p>Imagen - Texto Quiero Asociarme</p>
                <hr />
                {estadoSinInfo ? (
                    <React.Fragment>
                        <div className="plus_add_agencia align-items-center d-flex" onClick={() => { this.handleNew() }}>
                            {estadoNuevo ? <p>Cancelar &nbsp;<MDBIcon icon="times" size="lg" /></p> : <p>Agregar Nuevo &nbsp;<MDBIcon icon="plus-circle" size="lg" /></p>}
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment></React.Fragment>
                )}
                {estadoNuevo ? (
                    <React.Fragment>
                        <div className="justify-content-center d-flex">
                            <div className="text-center">
                                <FileUploader ref={this.uploader} estadoImg={estadoCambioImg1} FCambiar={this.cambioImagen1} />
                            </div>
                        </div>
                        <div className="container mt-5 pt-5 pb-5">
                            <div className="row">
                                <div className="col-md-6">
                                    <MDBInput label="Nombre" type="text" name="nombasociarme" value={nombasociarme} onChange={this.textInput} />
                                    {errors.nombasociarme && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.nombasociarme}</strong>}
                                </div>
                                <div className="col-md-6">
                                    <MDBInput label="Texto 1" type="text" name="txtasociarme1" value={txtasociarme1} onChange={this.textInput} />
                                    {errors.txtasociarme1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.txtasociarme1}</strong>}
                                </div>
                                <div className="col-md-6">
                                    <MDBInput label="Texto 2" type="text" name="txtasociarme2" value={txtasociarme2} onChange={this.textInput} />
                                    {errors.txtasociarme2 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.txtasociarme2}</strong>}
                                </div>
                                <div className="col-md-6 mt-3">
                                    <p>Color Texto</p>
                                    <div style={styles.swatch} onClick={this.handleClick}>
                                        <div style={styles.color} />
                                    </div>
                                    {this.state.displayColorPicker ? <div style={styles.popover}>
                                        <div style={styles.cover} onClick={this.handleClose} />
                                        <SketchPicker color={this.state.color} onChange={this.handleChange} />
                                    </div> : null}
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="button" className="btn btn-primary px-5" onClick={this.insertarDatos}>Guardar nuevo &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="listado_banner pt-5">
                            <p>Seleccionar banner</p>
                            <ul>
                                {infoQAsociarme.map((e, i) => {
                                    let view;
                                    if (e.estado === 1) {
                                        view = <MDBIcon icon="eye" size="lg" style={{ color: 'black', position: 'absolute', right: '-38px', marginTop: '5px' }} />
                                    } else {
                                        view = <MDBIcon onClick={() => { this.activar(e.idquieroasoc) }} icon="eye-slash" size="lg" style={{ color: 'black', position: 'absolute', right: '-38px', marginTop: '5px' }} />
                                    }
                                    return [
                                        <li key={i} id={e.idquieroasoc} onClick={() => { this.busquedaId(e.idquieroasoc) }}>{e.nombasociarme} {view}</li>
                                    ]
                                })}
                            </ul>
                        </div>
                        <div className="justify-content-center d-flex">
                            <div className="text-center">
                                {estadoImagen ? (
                                    <FileUploaderUpdate ref={this.uploader} ruta={rutaimgasociarm} estadoImg={estadoCambioImg} FCambiar={this.cambioImagen} />
                                ) : (
                                    <React.Fragment></React.Fragment>
                                )}
                            </div>
                        </div>
                        <div className="container mt-5 pt-5 pb-5">
                            <div className="row">
                                <div className="col-md-6">
                                    <MDBInput label="Nombre" type="text" name="editnombasociarme" value={this.state.editnombasociarme} onChange={this.textInput} />
                                </div>
                                <div className="col-md-6">
                                    <MDBInput label="Texto 1" type="text" name="edittxtasociarme1" value={this.state.edittxtasociarme1} onChange={this.textInput} />
                                </div>
                                <div className="col-md-6">
                                    <MDBInput label="Texto 2" type="text" name="edittxtasociarme2" value={this.state.edittxtasociarme2} onChange={this.textInput} />
                                </div>
                                <div className="col-md-6 mt-3">
                                    <p>Color Texto</p>
                                    <div style={styles.swatch} onClick={this.handleClick}>
                                        <div style={styles.color} />
                                    </div>
                                    {this.state.displayColorPicker ? <div style={styles.popover}>
                                        <div style={styles.cover} onClick={this.handleClose} />
                                        <SketchPicker color={this.state.color} onChange={this.handleChange} />
                                    </div> : null}
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="button" className="btn btn-success px-5" onClick={() => { this.actualizarDatos(this.state.idSeleccionado) }}>Guardar cambios &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default ImagenTexto;